import { ConnectPayouts } from '@stripe/react-connect-js'
import StripeConnectEmbeddedComponentManager from '@/components/stripe-connect/StripeConnectEmbeddedComponentManager'
import { STRIPE_CONNECT_PAYOUT_SECTION } from '@/components/stripe-connect/stripeConnectSurfaceContent'

export default function StripeConnectPayoutManager({
  organizationId,
  accountContext = 'current',
  onSessionConflict,
  onReadyChange,
  showSectionHeader = true,
}) {
  return (
    <StripeConnectEmbeddedComponentManager
      component={ConnectPayouts}
      title={STRIPE_CONNECT_PAYOUT_SECTION.title}
      description={STRIPE_CONNECT_PAYOUT_SECTION.description}
      errorTitle="Stripe payout tools are unavailable right now"
      minHeightClassName={STRIPE_CONNECT_PAYOUT_SECTION.minHeightClassName}
      organizationId={organizationId}
      accountContext={accountContext}
      onReadyChange={onReadyChange}
      onSessionConflict={onSessionConflict}
      showSectionHeader={showSectionHeader}
      surface="payouts"
      toastTitle="Unable to load Stripe payout tools"
    />
  )
}
